import firebase from 'firebase/compat/app';

export const getCurrentUser = () => {

    const encrypted_a = localStorage.getItem('encrypted_a');
    const encrypted_b = localStorage.getItem('encrypted_b');
    if (!encrypted_a || !encrypted_b) return null;

    const uid = localStorage.getItem('uid');
    const client_type = localStorage.getItem('client_type');
    const timezone = localStorage.getItem('timezone');
    return {
        id: uid,
        client_type: client_type,
        timezone: timezone,
        encrypted_a: encrypted_a,
        encrypted_b: encrypted_b,
    };

}
/* export const getCurrentUser = () => {
    const user = firebase.auth().currentUser;
    if (!user) return null;
    return {
        // on ne recupere de user que les données voulues
        id: user.uid,
    };
} */